import {
  Settings,
  User,
  HelpCircle,
  Bell,
  LogOut
} from '@geist-ui/icons';
import {
  ArrowLeftToLine,
  ArrowRightFromLine,
  Inbox,
  MessageSquareHeart,
  MessageSquare,
  BookUser,
  Pencil,
  Hash,
  Lock,
  Users,
  ChevronDown,
  ChevronUp,
  Pin,
  Trash2,
  Plus,
} from 'lucide-react';

// Icon props interface
export interface IconProps {
  size?: number;
  color?: string;
  className?: string;
  strokeWidth?: number;
}

export function IconSettings(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <Settings size={size} color={color} className={className} aria-hidden="true" />;
}

export function IconCollapse(props: IconProps & { isCollapsed?: boolean }) {
  const { size = 24, color, className = '', isCollapsed = false } = props;
  return isCollapsed 
    ? <ArrowRightFromLine size={size} color={color as string} className={className} strokeWidth={1.5} aria-hidden="true" /> 
    : <ArrowLeftToLine size={size} color={color as string} className={className} strokeWidth={1.5} aria-hidden="true" />;
}

export function IconTeams(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <Users size={size} color={color as string} strokeWidth={1.5} className={className} aria-hidden="true" />;
}

export function IconUser(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <User size={size} color={color} className={className} aria-hidden="true" />;
}

export function IconHelp(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <HelpCircle size={size} color={color} className={className} aria-hidden="true" />;
}

export function IconNotification(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <Bell size={size} color={color} className={className} aria-hidden="true" />;
}

export function IconHash(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <Hash size={size} color={color as string} strokeWidth={1.5} className={className} aria-hidden="true" />;
}

export function IconLock(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <Lock size={size} color={color as string} strokeWidth={1.5} className={className} aria-hidden="true" />;
}

export function IconLogout(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <LogOut size={size} color={color} className={className} aria-hidden="true" />;
}

export function IconInbox(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <Inbox size={size} color={color as string} strokeWidth={1.5} className={className} aria-hidden="true" />;
}

export function IconMessageHeart(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <MessageSquareHeart size={size} color={color as string} strokeWidth={1.5} className={className} aria-hidden="true" />;
}

export function IconMessageSquare(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <MessageSquare size={size} color={color as string} strokeWidth={1.5} className={className} aria-hidden="true" />;
}

export function IconContact(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <BookUser size={size} color={color as string} strokeWidth={1.5} className={className} aria-hidden="true" />;
}

export function IconPencil(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <Pencil size={size} color={color as string} strokeWidth={1.5} className={className} aria-hidden="true" />;
}

export function IconChevronDown(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <ChevronDown size={size} color={color as string} strokeWidth={1.5} className={className} aria-hidden="true" />;
}

export function IconChevronUp(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <ChevronUp size={size} color={color as string} strokeWidth={1.5} className={className} aria-hidden="true" />;
}

export function IconPin(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <Pin size={size} color={color as string} strokeWidth={1.5} className={className} aria-hidden="true" />;
}

export function IconTrash(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <Trash2 size={size} color={color as string} strokeWidth={1.5} className={className} aria-hidden="true" />;
}

export function IconPlus(props: IconProps) {
  const { size = 24, color, className = '' } = props;
  return <Plus size={size} color={color as string} strokeWidth={1.5} className={className} aria-hidden="true" />;
}

